// ko strings for messages/voice.ts. Same keys and {variables} as en there.
// SEO strings follow Korean search patterns ("{name} AI 목소리", "AI 커버").
import type { Dict } from "../index";

const voice: Dict = {
  // <head> and JSON-LD
  "voice.seo.title": "{name} AI 목소리: 듣고 AI 커버 만들기 | Jammable",
  "voice.seo.description":
    "{name} AI 커버를 듣고 1분 정도면 나만의 커버를 만들 수 있어요. 커뮤니티가 만든 {name} 목소리로 Jammable에서 노래, 텍스트 음성 변환, 듀엣을 만들어 보세요.",
  "voice.seo.appName": "{name} AI 목소리 생성기",
  "voice.seo.private": "비공개 목소리 | Jammable",
  "voice.name": "{name} AI 목소리",

  // Removed / private
  "voice.removed": "삭제된 목소리예요.",
  "voice.private": "비공개 목소리예요.",
  "voice.browseOther": "다른 목소리 둘러보기",

  "voice.error": "문제가 발생했어요. 다시 시도해 주세요",
  "voice.copied": "클립보드에 복사했어요!",

  // Hero
  "voice.newer.body":
    "{username} 님이 이 목소리를 업데이트했어요. 새 버전을 사용해 보세요",
  "voice.newer.cta": "새 버전",
  "voice.communityFavourite": "커뮤니티 인기",
  // {name} is replaced by the uploader's name, styled separately.
  "voice.uploadedBy": "업로드: {name}",
  "voice.voices.one": "목소리 {n}개",
  "voice.voices.other": "목소리 {n}개",
  "voice.createCover": "커버 만들기 · {uses}회 사용",
  "voice.like": "좋아요",
  "voice.unlike": "좋아요 취소",
  "voice.comments": "댓글",
  "voice.saveToCollection": "컬렉션에 저장",
  "voice.share": "목소리 공유",
  "voice.edit": "목소리 수정",
  "voice.report": "목소리 신고",
  "voice.delete": "목소리 삭제",
  "voice.more": "더보기",
  "voice.description": "설명",

  "voice.discord.label": "커뮤니티와 {name} 이야기 나누기",
  "voice.discord.labelNoName": "커뮤니티와 AI 목소리 이야기 나누기",
  "voice.discord.body":
    "Discord에서 커버를 공유하고, 새 목소리를 요청하고, 팁을 얻어 보세요",

  // Related voices. {badge} is the voice's category as stored (English).
  "voice.similar.title": "{name}와(과) 비슷한 AI 목소리",
  "voice.similar.sub": "사용자들이 {name}와(과) 함께 자주 사용한 목소리예요.",
  "voice.similar.moreHub": "{badge} 목소리 더보기",
  "voice.popularHub.title": "인기 {badge} AI 목소리",
  "voice.seeAll": "전체 보기",
  "voice.collections.title": "{name}이(가) 포함된 컬렉션",
  "voice.collections.titleNoName": "이 목소리가 포함된 컬렉션",
  "voice.pairWell.title": "{name}와(과) 잘 어울리는 목소리",

  // About
  "voice.about.title": "{name} AI 목소리 소개",
  "voice.about.use":
    "{name} AI 목소리로 AI 커버를 만들거나, 보이스 체인저로 쓰거나, 텍스트 음성 변환을 할 수 있어요.",
  "voice.about.categorised": "카테고리: {list}.",
  "voice.about.uses": "이 목소리는 Jammable에서 {n}회 사용됐어요.",
  "voice.howTo.title": "{name} AI 커버 만드는 방법",

  // FAQ
  "voice.faq.title": "{name} AI 목소리 자주 묻는 질문",
  "voice.faq.sub": "{name} 목소리로 커버를 만드는 방법을 모두 알려 드려요.",
  "voice.link.aiCover": "AI 커버 생성기",
  "voice.link.voiceChanger": "AI 보이스 체인저",
  "voice.link.browseAll": "모든 AI 목소리 둘러보기",
  "voice.link.weights": "Weights.gg 대안",
  "voice.faq.how.q": "{name} AI 커버는 어떻게 만드나요?",
  // {dmca} becomes the DMCA Policy link.
  "voice.faq.how.a":
    "{name} AI 커버를 만들려면 스튜디오에서 직접 오디오를 추가해야 해요({dmca}를 꼭 읽어 주세요). 추가한 뒤 변환 버튼을 누르면 30~60초 정도 후에 {name} AI 커버가 완성돼요.",
  "voice.faq.dmca": "DMCA 정책",
  "voice.faq.input.q": "{name} AI 커버에는 어떤 오디오를 사용할 수 있나요?",
  "voice.faq.input.a":
    "직접 만든 오리지널 오디오만 업로드할 수 있어요. 저작권자의 허락 없이 제3자의 저작권 자료가 포함된 음원을 사용해서는 안 돼요.",
  "voice.faq.time.q": "{name} AI 커버는 얼마나 걸리나요?",
  "voice.faq.time.a": "{name} AI 커버는 30~60초 정도면 완성돼요!",
  "voice.faq.credits.q": "{name} AI 커버 하나에 크레딧이 얼마나 드나요?",
  "voice.faq.credits.a": "{name} AI 커버 하나에 크레딧 1개만 사용돼요!",
  "voice.faq.acapella.q": "아카펠라를 업로드해야 하나요?",
  "voice.faq.acapella.a":
    "아니요. 아카펠라를 따로 업로드하지 않아도 시스템이 자동으로 보컬을 추출해 {name} AI 커버를 만들어요!",
  "voice.faq.changer.q": "{name} AI 목소리를 보이스 체인저로 쓸 수 있나요?",
  "voice.faq.changer.a":
    "네. {name} AI 목소리를 보이스 체인저나 텍스트 음성 변환에 사용할 수 있어요. 오디오를 업로드하거나 녹음하면 몇 초 만에 {name} 목소리로 변환돼요.",
  "voice.faq.free.q": "{name} AI 목소리는 무료인가요?",
  "voice.faq.free.a":
    "{name} AI 목소리 데모를 듣고 커버를 준비하는 것까지는 무료예요. 커버를 만들려면 Jammable 플랜이 필요하며, 플랜에서는 {name} AI 커버 무제한 생성, 다운로드 등을 이용할 수 있어요.",

  // TryVoiceSection
  "voice.demos.title": "먼저 들어 보세요",
  "voice.demos.note": "데모는 목소리 품질을 보여 주기 위해 자동 생성됐어요.",
  "voice.demos.maleSinging": "남성 보컬 {n}",
  "voice.demos.femaleSinging": "여성 보컬 {n}",
  "voice.demos.english": "영어",
  "voice.play": "{name} 재생",
  "voice.pause": "{name} 일시정지",

  // LibraryDemosSection
  "voice.library.title": "이 목소리로 부른 노래",
  "voice.library.sub":
    "AI {name} 목소리가 라이브러리의 인기곡을 부르는 걸 들어 보세요.",
  "voice.library.unknownSong": "알 수 없는 노래",
  "voice.library.unknownArtist": "알 수 없는 아티스트",

  // ModelCommentSection / ModelCommentItem
  "voice.comments.count.one": "댓글 {n}개",
  "voice.comments.count.other": "댓글 {n}개",
  "voice.comments.add": "댓글 추가",
  "voice.comments.post": "게시",
  "voice.comments.top": "인기순",
  "voice.comments.newest": "최신순",
  "voice.comments.empty": "아직 댓글이 없어요...",
  "voice.comments.emptySub": "첫 댓글을 남겨 보세요!",
  "voice.comments.more": "댓글 더보기",
  "voice.comments.posted": "댓글을 게시했어요!",
  "voice.comments.avatarAlt": "사용자 프로필 사진",
  "voice.comments.creator": "제작자",
  "voice.comments.pinned": "고정됨",
  "voice.comments.reply": "답글",
  "voice.comments.replyLabel": "답글",
  "voice.comments.replyPlaceholder": "어떻게 생각하세요?!",
  "voice.comments.viewReply.one": "답글 {n}개 보기",
  "voice.comments.viewReply.other": "답글 {n}개 보기",
  "voice.comments.viewMore": "{n}개 더보기",
  "voice.comments.justNow": "방금",
  "voice.comments.minutes": "{n}분",
  "voice.comments.hours": "{n}시간",
  "voice.comments.days": "{n}일",
  "voice.comments.repliesFailed": "답글을 불러오지 못했어요",
  "voice.comments.pinnedToast": "댓글을 고정했어요!",
  "voice.comments.unpinnedToast": "댓글 고정을 해제했어요!",
  "voice.comments.pinFailed": "댓글을 고정하지 못했어요",
  "voice.comments.pin": "댓글 고정",
  "voice.comments.unpin": "댓글 고정 해제",
  "voice.comments.delete": "댓글 삭제",
  "voice.comments.report": "댓글 신고",

  // AddToCollectionModal
  "voice.addTo.title": "컬렉션에 추가",
  "voice.addTo.error": "컬렉션을 불러오지 못했어요: {message}",
  "voice.addTo.empty": "컬렉션이 없어요...",
  "voice.addTo.emptySub": "첫 컬렉션을 만들어 보세요!",
  "voice.addTo.new": "새 컬렉션",
};

export default voice;
